import 'react-image-lightbox/style.css';
import React, { useCallback, useEffect, useState } from 'react';
import LightboxComponent from 'react-image-lightbox';

type LightboxProps = {
  images: string[];
  defaultImageIndex: number;
  close: () => void;
};

const Lightbox: React.FC<LightboxProps> = ({
  close,
  images,
  defaultImageIndex,
}) => {
  const [currentImageIndex, setCurrentImageIndex] = useState<number>(
    defaultImageIndex
  );
  const prev = useCallback(() => {
    const newIndex = currentImageIndex - 1;
    const maxIndex = images.length - 1;
    setCurrentImageIndex(newIndex < 0 ? maxIndex : newIndex);
  }, [currentImageIndex, images.length]);
  const next = useCallback(() => {
    const newIndex = currentImageIndex + 1;
    const maxIndex = images.length - 1;
    setCurrentImageIndex(newIndex > maxIndex ? 0 : newIndex);
  }, [currentImageIndex, images.length]);

  useEffect(() => {
    setCurrentImageIndex(defaultImageIndex);
  }, [defaultImageIndex]);

  return (
    <LightboxComponent
      mainSrc={images[currentImageIndex]}
      nextSrc={images[(currentImageIndex + 1) % images.length]}
      prevSrc={images[(currentImageIndex + images.length - 1) % images.length]}
      onCloseRequest={close}
      enableZoom={true}
      onMovePrevRequest={prev}
      onMoveNextRequest={next}
    />
  );
};

export default Lightbox;
